import React, { Component } from "react";
import './home.css';
import Navbar from '../navbar/navbar';
import Slideshow from '../slideshow/slideshow';
import About from '../about/about';
import Engagements from '../engagements/engagements';
import Weddings from '../weddings/weddings';
import Bespoke from '../bespoke/bespoke';
import Contact from '../contact/contact';

class Home extends Component {

  render() {
    return (
      <div>

        <Navbar />

        <div className="container-fluid">

          <section id="home">
            <Slideshow />
          </section>

          <section id="about">
            <About />
          </section>

          <section id="engagements">
            <Engagements />
          </section>

          <section id="weddings">
            <Weddings />
          </section>

          <section id="bespoke">
            <Bespoke />
          </section>

          <section id="contact">
            <Contact />
          </section>

        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/home/home.js